import { TableCell } from '@repo/go-table';
import type { GridRenderCellParams } from '@repo/go-table';
import { observer } from 'mobx-react-lite';
import { useTranslation } from 'react-i18next';

import type { RecommendationsValidationService } from '../services/RecommendationsValidationService';
import type { TRecommendationRowData } from '../types';

type Props = {
  params: GridRenderCellParams;
  validationService: RecommendationsValidationService;
};

export const RecommendationCell = observer(function RecommendationCell({ params, validationService }: Props) {
  const { t } = useTranslation();

  const errors = validationService.errors
    .get(params.id as string)
    ?.[params.field as keyof TRecommendationRowData]?.map((error: string) => <p key={error}>{t(error)}</p>);

  return (
    <TableCell
      style={{ backgroundColor: (!!errors?.length && 'var(--go-table-cell-error-bg-color)') || undefined }}
      message={errors?.length ? errors : undefined}
    >
      {params.formattedValue ?? (params.value == null || params.value === '' ? '-' : String(params.value))}
    </TableCell>
  );
});
